module.exports = __webpack_public_path__ + "static/media/payunimaid_logo.eb57a01d.png";